export const SPECIAL_PROMOTION_MODAL_KEY = 'newWarehouseSwissbox';
